import '@/js/dist/www.iichi.com/common';

import { createApp, h } from 'vue';
import { uniq } from '@/js/lib/helper/array';
import { lazyCreateApp } from '@/js/lib/helper/lazy-mount';
import { pinia } from '@/js/lib/store';
import { useItemStore } from '@/js/lib/store/item';
import LikeButtonSmall from '@/js/components/www.iichi.com/organisms/likeButtonSmall.vue';
import ListingMenu from '@/js/components/www.iichi.com/pages/listing/ListingMenu.vue';
import ListingMenuSp from '@/js/components/www.iichi.com/pages/listing/ListingMenuSp.vue';
import ListingSort from '@/js/components/www.iichi.com/pages/listing/ListingSort.vue';
import RecentSoldItems from '@/js/components/www.iichi.com/pages/listing/RecentSoldItems.vue';

const itemStore = useItemStore(pinia);

document.addEventListener('DOMContentLoaded', () => {
  const likeButtonEls: NodeListOf<HTMLElement> = document.querySelectorAll('like-button-small');
  if (likeButtonEls.length > 0) {
    const itemIds = Array.from(likeButtonEls, (el) => Number(el.dataset.itemId));
    itemStore.initLikedData(uniq(itemIds));

    likeButtonEls.forEach((el) => {
      createApp({
        render: () =>
          h(LikeButtonSmall, {
            itemId: Number(el.dataset.itemId),
          }),
      }).mount(el);
    });
  }

  const listingMenuEl = document.querySelector('listing-menu') as HTMLElement;
  createApp({
    render: () =>
      h(ListingMenu, {
        initialQuery: listingMenuEl.dataset.initialQuery!,
        initialCategory: listingMenuEl.dataset.initialCategory!,
        initialSubCategory: listingMenuEl.dataset.initialSubCategory!,
        initialFromPrice: listingMenuEl.dataset.initialFromPrice!,
        initialToPrice: listingMenuEl.dataset.initialToPrice!,
        initialMaterial: listingMenuEl.dataset.initialMaterial!,
        initialColor: listingMenuEl.dataset.initialColor!,
        initialGift: listingMenuEl.dataset.initialGift!,
        initialOrdermade: listingMenuEl.dataset.initialGift!,
        initialVintage: listingMenuEl.dataset.initialVintage!,
        initialSelling: listingMenuEl.dataset.initialSelling!,
        sort: listingMenuEl.dataset.sort!,
        order: listingMenuEl.dataset.order!,
      }),
  }).mount(listingMenuEl);

  const listingMenuSpEl = document.querySelector('listing-menu-sp') as HTMLElement;
  createApp({
    render: () =>
      h(ListingMenuSp, {
        initialQuery: listingMenuSpEl.dataset.initialQuery!,
        initialCategory: listingMenuSpEl.dataset.initialCategory!,
        initialSubCategory: listingMenuSpEl.dataset.initialSubCategory!,
        initialFromPrice: listingMenuSpEl.dataset.initialFromPrice!,
        initialToPrice: listingMenuSpEl.dataset.initialToPrice!,
        initialMaterial: listingMenuSpEl.dataset.initialMaterial!,
        initialColor: listingMenuSpEl.dataset.initialColor!,
        initialGift: listingMenuSpEl.dataset.initialGift!,
        initialOrdermade: listingMenuSpEl.dataset.initialGift!,
        initialVintage: listingMenuSpEl.dataset.initialVintage!,
        initialSelling: listingMenuSpEl.dataset.initialSelling!,
        sort: listingMenuSpEl.dataset.sort!,
        order: listingMenuSpEl.dataset.order!,
      }),
  }).mount(listingMenuSpEl);

  const listingSortEl = document.querySelector('listing-sort') as HTMLElement;
  createApp({
    render: () =>
      h(ListingSort, {
        params: listingSortEl.dataset.params!,
        sort: listingSortEl.dataset.sort!,
        order: listingSortEl.dataset.order!,
      }),
  }).mount(listingSortEl);

  const recentSoldItemsEl = document.querySelector('recent-sold-items') as HTMLElement;
  lazyCreateApp(
    {
      render: () =>
        h(RecentSoldItems, {
          categoryId: recentSoldItemsEl.dataset.categoryId!,
        }),
    },
    recentSoldItemsEl,
  );
});
